// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-core-pages-RoutingErrorPage-RoutingErrorPage-module__errorPage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-bg-default);
  color: var(--color-typo-primary);
  overflow: hidden;
}

.src-core-pages-RoutingErrorPage-RoutingErrorPage-module__actions {
  display: flex;
  flex-direction: row;
  gap: var(--space-2xs);
}`, "",{"version":3,"sources":["webpack://./src/core/pages/RoutingErrorPage/RoutingErrorPage.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,gCAAA;EACA,gBAAA;AACJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;AAEJ","sourcesContent":[".errorPage{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: var(--color-bg-default);\n    color:var(--color-typo-primary);\n    overflow: hidden;\n}\n.actions{\n    display: flex;\n    flex-direction: row;\n    gap: var(--space-2xs);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorPage": `src-core-pages-RoutingErrorPage-RoutingErrorPage-module__errorPage`,
	"actions": `src-core-pages-RoutingErrorPage-RoutingErrorPage-module__actions`
};
export default ___CSS_LOADER_EXPORT___;
